
export interface ClientInfo {
  userAgent?: string;
  browser?: string;
  os?: string;
  device?: string;
}

export const getClientInfo = (): ClientInfo => {
  const userAgent = navigator.userAgent;
  let browser = "Unknown";
  let os = "Unknown";
  let device = "Unknown";
  
  // Detect browser
  if (userAgent.indexOf("Firefox") > -1) {
    browser = "Firefox";
  } else if (userAgent.indexOf("SamsungBrowser") > -1) {
    browser = "Samsung Browser";
  } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
    browser = "Opera";
  } else if (userAgent.indexOf("Trident") > -1) {
    browser = "Internet Explorer";
  } else if (userAgent.indexOf("Edge") > -1) {
    browser = "Edge";
  } else if (userAgent.indexOf("Chrome") > -1) {
    browser = "Chrome";
  } else if (userAgent.indexOf("Safari") > -1) {
    browser = "Safari";
  }
  
  // Detect OS
  if (userAgent.indexOf("Win") > -1) {
    os = "Windows";
  } else if (userAgent.indexOf("Mac") > -1) {
    os = "MacOS";
  } else if (userAgent.indexOf("Android") > -1) {
    os = "Android";
  } else if (userAgent.indexOf("like Mac") > -1) {
    os = "iOS";
  } else if (userAgent.indexOf("Linux") > -1) {
    os = "Linux";
  }
  
  // Detect device type
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) {
    device = "Tablet";
  } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(userAgent)) {
    device = "Mobile";
  } else {
    device = "Desktop";
  }
  
  return {
    userAgent,
    browser,
    os,
    device
  };
};
